import { lazy, type ComponentType } from "react";

const RELOAD_FLAG = "chunk-reload-attempted";

/**
 * React.lazy that recovers from a deploy: a tab opened before the deploy asks for
 * chunk files that no longer exist, so reload once to pick up the new build.
 */
export function lazyWithReload<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(RELOAD_FLAG);
      return module;
    } catch (err) {
      if (!sessionStorage.getItem(RELOAD_FLAG)) {
        sessionStorage.setItem(RELOAD_FLAG, "1");
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    }
  });
}
